exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".monitor-container[data-v-36759212]{overflow:auto;height:100vh}.monitor-container--map[data-v-36759212]{overflow:auto;height:50%}h2[data-v-36759212]{padding:0 1rem}", ""]);

